
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"30","rx":"15","fill":"#EAEDFF"}}),_c('path',{attrs:{"d":"M19.17 18.338h1.667v-10h-8.333v1.667h6.666v8.333zm0 1.667v2.5c0 .46-.375.834-.839.834H8.343a.835.835 0 01-.84-.834l.003-11.666c0-.46.375-.834.84-.834h2.491v-2.5c0-.46.373-.833.833-.833h10c.46 0 .834.373.834.833v11.667c0 .46-.373.833-.834.833h-2.5zm-8.333-1.666v1.666h1.667v.834h1.666v-.834h.417a2.083 2.083 0 000-4.166h-2.5a.417.417 0 110-.834h3.75v-1.667H14.17v-.833h-1.666v.833h-.417a2.083 2.083 0 000 4.167h2.5a.417.417 0 010 .834h-3.75z","fill":"#2B4BFF"}})])
          )
        }
      }
    